import React, { useState } from 'react';
import { gallery } from '../mock';
import GalleryGrid from '../components/GalleryGrid';
import SEO from '../components/SEO';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  const categories = ['All', ...new Set(gallery.map(item => item.category))];
  
  const filteredGallery = selectedCategory === 'All' 
    ? gallery 
    : gallery.filter(item => item.category === selectedCategory);

  return (
    <div className="gallery-page">
      <SEO 
        title="Before & After Gallery | Home Improvement Projects | SBF | Fayette County, PA"
        description="View our portfolio of completed roofing, siding, deck, flooring & renovation projects in Fayette County. Real before & after photos from Ohiopyle, Chalkhill, Mt Pleasant & more."
        keywords="before after photos, home improvement portfolio, roofing projects, deck construction photos, siding installation gallery, Fayette County projects"
      />
      {/* Hero Section */}
      <section style={{background: 'var(--bg-page)', padding: '120px 40px 80px'}}>
        <div className="container">
          <h1 className="heading-1" style={{color: 'var(--text-primary)', marginBottom: '24px'}}>PROJECT GALLERY</h1>
          <p className="body-large" style={{color: 'var(--text-secondary)', maxWidth: '60ch'}}>See our work. Real transformations, real results.</p>
        </div>
      </section>

      {/* Filter Section */}
      <section style={{background: 'var(--bg-card)', padding: '40px'}}>
        <div className="container">
          <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center'}}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={selectedCategory === category ? 'btn-primary' : 'btn-secondary'}
                style={{padding: '12px 24px'}}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section style={{background: 'var(--bg-page)', padding: '96px 40px'}}>
        <div className="container">
          <GalleryGrid items={filteredGallery} />
        </div>
      </section>
    </div>
  );
};

export default Gallery;